// extracted by mini-css-extract-plugin
module.exports = {"customHeader":"Variance_customHeader__Hkt8H"};